import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { pendingScan, takePendingScan } from "./pending";
import type { ScanKind, ScanResult } from "./types";

const PAGE: Record<ScanKind, string> = {
  receipt: "/app/inventory/deliveries",
  invoice: "/app/inventory/invoices",
  order: "/app/inventory/orders",
};

/**
 * Scanning on a page: the dialog's open flag, and where a result goes — this
 * page's editor for its own kind, another page for the others (handed over
 * through pendingScan and picked up on that page's mount).
 */
export function useScanRouting(kind: ScanKind, openHere: (result: ScanResult) => void) {
  const router = useRouter();
  const scanning = ref(false);

  onMounted(() => {
    const pending = takePendingScan(kind);
    if (pending) openHere(pending);
  });

  const onOpen = (k: ScanKind, result: ScanResult) => {
    scanning.value = false;
    if (k === kind) {
      openHere(result);
    } else {
      pendingScan.value = { kind: k, result };
      router.push(PAGE[k]);
    }
  };

  return { scanning, onOpen };
}
